import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import getOverReimbursements, {
  PagedOverReimbursements,
} from 'core/application/adminDashboard/reimbursements/overReimbursements/getOverReimbursements'
import OrderedPageFilter from 'core/application/commons/orderedPageFilter'

import { Col, Row, Table } from 'common/components'
import { useQueryRequestV2 } from 'common/hooks'

import { overReimbursementsColumns } from './OverReimbursementsColumns'

import './OverReimbursements.less'

const pagedColumnDefaultValues = {
  items: [],
  pageCount: 1,
  pageNumber: 1,
  pageSize: 10,
  totalItemCount: 0,
}

const defaultFilter = {
  pageNumber: 1,
  pageSize: 10,
  orderColumn: 'fullName',
  orderDescending: false,
}

interface ReimbursementsHistoryProps {
  planPeriodId: string
}

const ReimbursementsHistory = ({ planPeriodId }: ReimbursementsHistoryProps) => {
  const [overReimbursementsFilter, setOverReimbursementsFilter] = useState<OrderedPageFilter>(defaultFilter)
  const { t: translate } = useTranslation()
  const {
    sendQuery: sendGetOverReimbursements,
    data: overReimbursements,
    isLoading: loadingOverReimbursements,
  } = useQueryRequestV2<PagedOverReimbursements>({
    initialState: pagedColumnDefaultValues,
    queryFn: () => getOverReimbursements(overReimbursementsFilter, planPeriodId),
    enable: !!planPeriodId,
  })

  useEffect(() => {
    sendGetOverReimbursements(() => getOverReimbursements(overReimbursementsFilter, planPeriodId))
  }, [planPeriodId, overReimbursementsFilter])

  const onOverReimbursementsTableChange = (pagination: any, filters: any, sorter: any) => {
    setOverReimbursementsFilter({
      pageNumber: pagination.current,
      pageSize: pagination.pageSize,
      orderColumn: sorter.field || 'fullName',
      orderDescending: sorter.order !== 'ascend',
    })
  }

  return (
    <Row className="over_reimbursements_table mt-24">
      <Col span={24}>
        <Table
          className={'t-over-reimbursements'}
          dataSource={overReimbursements.items}
          onChange={onOverReimbursementsTableChange}
          loading={loadingOverReimbursements}
          scroll={{ x: 1000 }}
          columns={overReimbursementsColumns(translate, overReimbursementsFilter)}
          pagination={{
            total: overReimbursements.totalItemCount,
            pageSize: overReimbursements.pageSize,
            current: overReimbursements.pageNumber,
          }}
          rowKey="companyUserId"
        />
      </Col>
    </Row>
  )
}

export default ReimbursementsHistory
